<template>
  <m-button
    type="text"
    v-bind="$attrs"
    v-on="$listeners">
    <m-icon
      v-if="icon"
      slot="icon"
      :icon="icon" />
    <slot />
  </m-button>
</template>

<script>
import Vue from 'vue'
import MButton from 'material-components-vue/dist/button'
import Icon from 'material-components-vue/dist/icon'
Vue.use(Icon)
Vue.use(MButton)

export default {
  props: {
    icon: { default: '', required: false, type: String }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/button/styles";

  .mdc-button {
    text-transform: initial;
  }
  .mdc-button--raised:not(:disabled), .mdc-button--raised:not(:disabled) i {
    color: white;
  }
  .round {
    border-radius: 200px;
  }
  .create.mdc-button--raised:not(:disabled), .create.mdc-button--unelevated:not(:disabled) {
    background-color: $mdc-theme-secondary;
  }
  .create {
    height: 48px;
    padding-left: 24px;
    padding-right: 24px;
    font-size: 14px;
    text-transform: none;
    .mdc-icon-button__icon {
      font-size: 24px;
      height: 24px;
      width: 24px;
      & i {
        color: white;
      }
    }
  }

.btn-color--primary.mdc-button--raised[data-v-46e548df]:not(:disabled),
.btn-color--primary.mdc-button--unelevated[data-v-46e548df]:not(:disabled) {
  background-color: $mdc-theme-primary;
}
.btn-color--secondary.mdc-button--raised[data-v-46e548df]:not(:disabled),
.btn-color--secondary.mdc-button--unelevated[data-v-46e548df]:not(:disabled) {
  background-color: $mdc-theme-secondary;
}
.btn-color--destructive.mdc-button--raised[data-v-46e548df]:not(:disabled),
.btn-color--destructive.mdc-button--unelevated[data-v-46e548df]:not(:disabled) {
  background-color: $mdc-theme-error;
}
</style>
